import styled from "styled-components";
import { titleCase } from "change-case-all";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Avatar, IconButton } from "@mui/material";
import { IoIosArrowDown } from "react-icons/io";

import pages from "../../constants/pages";
import { colors } from "../../pages/css components/Style";
import DropDownButton from "./navbar components/DropDownButton";
import Sprintex from "../../assets/Sprintex.png";
import { LogoutIcon } from "./sidebar components/sidebar icons/BrandProfile";
import { signOutMember } from "../../redux/slices/memberSlice";

const Wrapper = styled.div`
  position: sticky;
  top: 0;
  min-height: 64px;
  border-radius: 0px;
  background: ${colors.sprintexBlue};
  padding: 10px;
  display: flex;
  justify-content: space-between;
  box-shadow: 0 5px 5px -5px rgba(35, 37, 38, 0.15);
`;

const BrandDiv = styled.div`
  display: flex;
`;

const ImageDiv = styled.div`
  width: 220px;
  height: 40px;
`;

const Image = styled.img`
  height: inherit;
  width: inherit;
`;

export default function Navbar() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { activeBrand, role, agency, dashboardPermissions } = useSelector(
    (state) => state.memberDetails
  );

  return (
    <Wrapper>
      <div style={{ display: "flex", gap: "30px", alignItems: "center" }}>
        <ImageDiv
          onClick={() => {
            const isAdminBrand = dashboardPermissions.some(
              (page) => page.ID === "administrator-brands"
            );

            const path = isAdminBrand
              ? pages.accountVerification.route
              : pages.brandDetails.route;

            navigate(path);
            // setSelectedMenu(path);
          }}
        >
          <Image src={Sprintex} alt="!" />
        </ImageDiv>

        {(role === "NORMAL_USER" || role === "AGENCY") && (
          <div
            className="brand-switch-logo"
            onClick={() => navigate(pages.welcomePage.route)}
          >
            <Avatar
              style={{
                height: "25px",
                width: "25px",
                cursor: "pointer",
                marginRight: "10px",
              }}
              src={role === "AGENCY" ? agency.agencyLogo : activeBrand.logo}
            />
            {role === "AGENCY"
              ? titleCase(agency.agencyName)
              : titleCase(activeBrand.brandName)}

            <IoIosArrowDown style={{ fontSize: "18px", marginLeft: "10px" }} />
          </div>
        )}
      </div>

      <BrandDiv>
        <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
          {/* <IoIosNotifications
            style={{
              color: "white",
              height: "30px",
              width: "30px",
            }}
          /> */}

          <DropDownButton />

          <IconButton onClick={() => dispatch(signOutMember())}>
            <LogoutIcon />
          </IconButton>
        </div>
      </BrandDiv>
    </Wrapper>
  );
}
